<template>
  <div>
    <div class="toolBar">
      <MainToolBbarStaff></MainToolBbarStaff>
      <ul class="toolList">
        <li style="cursor: pointer;">
          <img src="../../../static/img/friendList-icon.png" alt @click="handleClick"  />
          <div v-if="GroupUnreadCount!='0'">
            <span>{{GroupUnreadCount}}</span>
          </div>
        </li>
      </ul>
      <a class="setting">
        <img src="../../../static/img/setting-icon.png" alt />
      </a>
      <img class="scrmLogo" src="../../../static/img/SCRM-badge.png" alt />
    </div>
  </div>
</template>


<script>
import MainToolBbarStaff from "../../components/Main/MainToolBbarStaff.vue";
import store from "../../vuex/store_friendList.js";
export default {
  name: "MainToolBar",
  components: { MainToolBbarStaff },
  computed: {
    GroupUnreadCount: {
      get: function() {
        var unread = store.state.groupUnread;
        if (unread == null && unread == undefined) {
          return "0";
        }

        if (unread.length == 0) {
          return "0";
        }
        if (unread.TotalNum > 999) {
          return "999+";
        }

        return unread.TotalNum;
      },
      set: function() {}
    }
  },
  data() {
    return {};
  },
  methods: {
    handleClick:function(){
        this.$emit('collapseFriendGroup')
    }

  }
};
</script> 



<style>
</style>


// WEBPACK FOOTER //
// src/components/Main/MainToolBar.vue